import { render, staticRenderFns } from "./SoldPinsListPage.vue?vue&type=template&id=c75c739a&scoped=true&"
import script from "./SoldPinsListPage.vue?vue&type=script&lang=js&"
export * from "./SoldPinsListPage.vue?vue&type=script&lang=js&"
import style0 from "./SoldPinsListPage.vue?vue&type=style&index=0&id=c75c739a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c75c739a",
  null
  
)

export default component.exports